import React from 'react';

// Shared toggle switch. Was three near-identical copies (StaffDrawer.js,
// LocationDrawer.js, ShiftTypesPage.js) with two different prop APIs;
// consolidated here on the isOn/onClick shape the first two already agreed
// on, since that was the majority convention.
const Switch = ({ isOn, onClick, activeTrack, inactiveTrack = "bg-slate-400", knobColor = "bg-white" }) => (
  <button
    onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick(); }}
    className={`w-10 h-5.5 rounded-full relative transition-all duration-300 ease-in-out ${isOn ? (activeTrack || inactiveTrack) : inactiveTrack} flex items-center shadow-inner`}
    style={{ minWidth: '40px', height: '22px' }}
  >
    <div className={`absolute w-4 h-4 ${knobColor} rounded-full shadow-sm transition-all duration-300 ease-in-out ${isOn ? 'left-[20px]' : 'left-1'}`} />
  </button>
);

export default Switch;
